import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Checkmark = () => (
    <SingePathIcon path="M4.92374 9.27724C4.69603 9.27724 4.46832 9.18767 4.30386 9.02131L0.584546 5.25911C0.242977 4.91361 0.242977 4.35056 0.584546 4.00505C0.926116 3.65954 1.48275 3.65954 1.82432 4.00505L4.88579 7.10182L10.8063 0.575562C11.1352 0.217258 11.6919 0.191665 12.0461 0.524376C12.4003 0.857087 12.4256 1.42014 12.0967 1.77844L5.58158 8.99572C5.41712 9.17487 5.18941 9.27724 4.94905 9.29004C4.93639 9.27724 4.93639 9.27724 4.92374 9.27724Z" />
);

Checkmark.viewBox = `0 0 13 10`;
